import React, { useEffect, useState } from 'react';
import TextInfo, {
  FONT_TYPE,
  SIZE,
  KIND_TEXT,
  SEGMENT,
  ALIGN,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import './IncrementalFigures.scss';

const IncrementalFigures = ({ components }) => {
  const [count, setCount] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const arrayCounts = [count, count2, count3];

  // tiempo predefinido de carga en ms: 3000ms
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count + 1);
    }, 3000 / components[0].count);
    if (count === components[0].count) clearInterval(interval);
    return () => clearInterval(interval);
  }, [count]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount2(count2 + 1);
    }, 3000 / components[1].count);
    if (count2 === components[1].count) clearInterval(interval);
    return () => clearInterval(interval);
  }, [count2]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount3(count3 + 1);
    }, 3000 / components[2].count);
    if (count3 === components[2].count) clearInterval(interval);
    return () => clearInterval(interval);
  }, [count3]);

  const showCounters = (elements) => {
    elements.forEach((element) => {
      if (element.isIntersecting && !element.target.classList.contains('animate')) {
        element.target.classList.add('animate');
        element.target.classList.remove('hide');
        setTimeout(() => {
          setCount(0);
          setCount2(0);
          setCount3(0);
        }, 300)
      }
    });
  };

  const observer = new IntersectionObserver(showCounters, {
    threshold: 0.5,
  });

  useEffect(() => {
    const elementsHTML = document.querySelectorAll('.IncrementalFigures__item-count');
    elementsHTML.forEach((elementHTML) => {
      observer.observe(elementHTML)
    })
  }, []);


  return (
    <section className="IncrementalFigures">
      <div className="IncrementalFigures__container container">
        {
        components.map((component, index) => (
          <div className="IncrementalFigures__item" key={component[index]}>
            <TextInfo
              kind={KIND_TEXT.SPAN}
              align={ALIGN.CENTER}
              size={SIZE.DISPLAY1}
              fontType={FONT_TYPE.LIGHT}
              text={`${arrayCounts[index]}${component.percentage}`}
              segment={SEGMENT.EMP}
              className="hide IncrementalFigures__item-count"
            />
            <TextInfo {...component['TextInfo-2']} className="IncrementalFigures__item-subtitle" />
          </div>
        ))
      }
      </div>
    </section>
  );
};

export default IncrementalFigures;
